import React, { useState, useRef,useEffect } from "react";
// import "./Inputform.css";
import L from "leaflet";
import { message,Button  } from "antd";
import Logo2 from "../../images/MMRCLogo.svg";
import UploadIcon from "../../images/UploadIcon.svg";
import ResetIcon from "../../images/ResetIcon.svg"; // Add reset icon SVG/image
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CompensatoryIcon from "../../images/CompensatoryTrees.svg";
import TransplantIcon from "../../images/TransplantTrees.svg";
import InSituIcon from "../../images/InSituTrees.svg";
import UserInfoSVG from "../../images/UserInfoSVG.svg";
import ArrowSVG from "../../images/ArrowSVG.svg";
import { BaseURL } from "../../Utils/baseURL";
import UserAccount from '../Auth/UserAccount';
import LocationMarker from "../../images/LocationMarker.svg";
import LatLongIcon from "../../images/LatLongIcon.svg";

const TreeGeotaggingForm = () => {
  const navigate = useNavigate();
    const [currentLocation, setCurrentLocation] = useState(null);
    const [activeButton, setActiveButton] = useState(null); 
 
    
  const [formData, setFormData] = useState({
    surveyType: "",
    treeName: "",
    station: "",
    latitude: null,
    longitude: null,
    locationDescription: "",
    girth: "",
    height: "",
    package: "",
    remark: "",
    girthUnit: "cm", // Default
    heightUnit: "ft", // Default
  });
   const mapRef = useRef(null);
   const markerRef = useRef(null);
  const [imageFile, setImageFile] = useState(null);
  const [stations, setStations] = useState([]);
  const [treeNames, setTreeNames] = useState([]);
  const token = sessionStorage.getItem("token");
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [user, setUser] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const handleFlyToCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setFormData((prevData) => ({
            ...prevData,
            latitude: latitude.toFixed(6),
            longitude: longitude.toFixed(6),
          }));
  
          message.success("Current location fetched successfully!");
  
          // Ensure map is loaded before calling flyTo
          if (mapRef.current && window.L) {
            mapRef.current.flyTo([latitude, longitude], 13, { animate: true });
          } else {
            console.warn("Leaflet map is not initialized yet.");
          }
        },
        (error) => {
          console.error("Error fetching location:", error);
          message.error("Unable to fetch current location. Please try again.");
        }
      );
    } else {
      message.error("Geolocation is not supported by this browser.");
    }
  };
  

   const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    sessionStorage.removeItem('token');
    message.success("Logout successful!");
    setIsAccountOpen(false);
    navigate('/');
  };
  
  const fetchUserData = async (token) => {
    try {
      const response = await fetch(`${BaseURL}/auth/users/details/`, {
        method: "GET",
        headers: {
          "Authorization": `token ${token}`,
          "Content-Type": "application/json",
        },
      });
  
      if (response.ok) {
        const responseData = await response.json();
        setUser(responseData.data);
      } else {
        console.error("Failed to fetch user data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  
  useEffect(() => {
    const fetchStations = async () => {
      try {
        const stationResponse = await axios.get(`${BaseURL}/program/stations/`, {
          headers: { Authorization: `token ${token}` },
        });
  
    
  
        setStations(stationResponse.data.data || []);
        sessionStorage.setItem('stations', JSON.stringify(stationResponse.data.data));
      } catch (error) {
        console.error("Error fetching stations:", error);
      }
    };
  
    const fetchTreeNames = async () => {
      // Check if tree names are already stored in sessionStorage
      const storedTreeNames = sessionStorage.getItem('treeNames');
      if (storedTreeNames) {
        setTreeNames(JSON.parse(storedTreeNames));
      } else {
        try {
          const treeResponse = await axios.get(`${BaseURL}/survey/trees/list/`, {
            headers: { Authorization: `token ${token}` },
          });
          setTreeNames(treeResponse.data.data.map(tree => ({
            id: tree.id,
            name: tree.name,
          })));
          sessionStorage.setItem('treeNames', JSON.stringify(treeResponse.data.data));
        } catch (error) {
          console.error("Error fetching tree names:", error);
        }
      }
    };
  
    fetchStations();
    fetchTreeNames();
  }, [token]);
  

  const toggleAccount = () => {
    setIsAccountOpen((prev) => !prev);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: ["treeType", "station", "package", "project"].includes(name)
        ? parseInt(value, 10) || "" // Convert to integer
        : ["latitude", "longitude"].includes(name)
        ? parseFloat(value) || "" // Convert to float
        : value,
    }));
  };

  
  const handleTreeSelection = (e) => {
    const selectedTreeId = e.target.value;
    const selectedTree = treeNames.find(tree => tree.id === parseInt(selectedTreeId, 10));
  
    setFormData((prevData) => ({
      ...prevData,
      treeType: selectedTree ? selectedTree.id : "", // ✅ Auto-assign tree ID
      treeName: selectedTree ? selectedTree.name : "", // ✅ Store tree name for display
    }));
  };
  
  

  const handleImageChange = (e) => {
    if (e.target.files.length > 0) {
      setImageFile(e.target.files[0]); // ✅ Ensure image is stored correctly
      
    }
  };
  
  
  const handleClearAll = () => {
    setFormData({
      surveyType: "in_situ",
      treeName: "",
      station: "",  // ✅ Ensure station is reset properly
      latitude: "",
      longitude: "",
      locationDescription: "",
      girth: "",
      girthUnit: "cm",
      height: "",
      heightUnit: "ft",
      package: "",
      remark: "",
      project: "",
    });
    setImageFile(null);
  };
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
   
  
    if (
      !formData.project ||
      !formData.treeType ||
      !formData.station || isNaN(formData.station) ||
      !formData.latitude ||
      !formData.longitude ||
      !imageFile
    ) {
      alert("Please fill all required fields.");
      return;
    }
  
    const data = new FormData();
    data.append('survey_type', formData.surveyType.toLowerCase());  
    data.append('location', JSON.stringify({  // ✅ Correct format
      latitude: parseFloat(formData.latitude),
      longitude: parseFloat(formData.longitude),
    }));
    data.append('station', formData.station);
    data.append('package', formData.package || "");
    data.append('location_description', formData.locationDescription || "");
    data.append('tree_type', formData.treeType);
    data.append('girth', formData.girth || "");
    data.append('girth_unit', formData.girthUnit || "");
    data.append('height', formData.height || "");
    data.append('height_unit', formData.heightUnit || "");
    data.append('remark', formData.remark || "");
    data.append('image', imageFile); 
    data.append('project', formData.project);
  
    try {
      const response = await axios.post(`${BaseURL}/survey/tree-surveys/create/`, data, {
        headers: {
          Authorization: `token ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.status === 200) {
        alert("Form submitted successfully!");
      
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert(`Failed to submit form: ${error.response ? JSON.stringify(error.response.data) : error.message}`);
    }
  };
  
  
  
  
  
  
  
  
  
  
  
  return (
    <form onSubmit={handleSubmit} className="tree-form">
      {/* Header Section */}
      <div className="form-header">
        <div className="left-header">
          <img src={Logo2} alt="Logo" className="logo1" />
          <div className="header-text">
            <h2>Mumbai Metro Line 3</h2>
            <h3>Tree Geotagging</h3>
          </div>
        </div>
        
        <div className="right-header">
          <div className="header-links">
            <a href="/" className="back-home">
              <img src={ArrowSVG} alt="Arrow" className="arrow-svg" />
              Back to Home
            </a>
            <div className="user-info">
              <Button onClick={toggleAccount} className="user-info-btn" >
                <img  src={UserInfoSVG} alt="User Info" className="user-info-svg" />
              </Button>
              {isAccountOpen && (
                <UserAccount
                  user={user}
                  onLogout={handleLogout}
                  onClose={() => setIsAccountOpen(false)}
                />
              )}
            </div>
          </div>
        </div>
      </div>


      {/* Form Layout */}
      <div className="form-layout">
        {/* Left ide */}
        <div className="form-left">
          <p className="section-title-left">Add Tree Details:</p>
          <label className="upload-area">
            <input type="file" className="upload-input" onChange={handleImageChange} />
            <div className="upload-placeholder">
              <img src={UploadIcon} alt="Upload icon" />
              <span>
                Drop your Image here, or <strong>browse</strong>
              </span>
              <p>Supports: JPG and PNG</p>
            </div>
          </label>
        </div>

        {/* Right ide */}
        <div className="form-right">
        <div className="form-right-cont">

        <div className="survey-type-container">
          <h4 className="section-title">Survey Type *:</h4>
          <button
            type="button"
            className="clear-all"
            onClick={handleClearAll}
            title="Clear All"
          >
            Clear All<img src={ResetIcon} alt="Reset Icon" /> 
          </button>
        </div>

        <div className="survey-type">
          {["in_situ", "transplant", "compensatory"].map((type) => (
            <div key={type} className="survey-chip-container">
              <input
                type="radio"
                id={`radio-${type}`} // Unique id for each input
                name="surveyType"
                value={type}
                checked={formData.surveyType === type}
                onChange={handleInputChange}
                className="radio-input"
              />
              <label
                htmlFor={`radio-${type}`} // Associate label with input
                className={`survey-chip ${
                  formData.surveyType === type ? "active" : ""
                } ${type.toLowerCase()}`}
              >
                <span>
                  {type === "in_situ" && <img src={InSituIcon} alt="Insitu Icon" />}
                  {type === "transplant" && (
                    <img src={TransplantIcon} alt="Transplant Icon" />
                  )}
                  {type === "compensatory" && (
                    <img src={CompensatoryIcon} alt="Compensatory Icon" />
                  )}
                  {type}
                </span>
              </label>
            </div>
          ))}
        </div>



          <div className="tree-details-container">
              <h4 className="section-title">Tree Details*:</h4>
              <div className="tree-details">
              <div className="form-group">
                <label htmlFor="project">Project Number</label>
                <input
                  id="project"
                  type="text"
                  name="project"
                  placeholder="Project Number"
                  value={formData.project}
                  onChange={handleInputChange}
                />
              </div>


              <div className="form-group">
                <label htmlFor="treeName">Tree Name</label>
                <select id="treeType" name="treeType" value={formData.treeType} onChange={handleTreeSelection}>
                  <option value="">Select Tree Name</option>
                  {treeNames.map((tree) => (
                    <option key={tree.id} value={tree.id}>{tree.name}</option>
                  ))}
                </select>


                </div>

                <div className="form-group">
                <label htmlFor="station">Station</label>
                <select
                  id="station"
                  name="station"
                  value={formData.station || ""}
                  onChange={(e) => {
                   

                    if (e.target.value !== "") {
                      setFormData((prevData) => ({
                        ...prevData,
                        station: parseInt(e.target.value, 10), // Store as an integer
                      }));
                    } else {
                      setFormData((prevData) => ({ ...prevData, station: "" })); // Reset if empty
                    }
                  }}
                >
                  <option value="">Select Station</option>
                  {stations.length > 0 ? (
                    stations.map((station) => (
                      <option key={station.id} value={station.id}>
                        {station.name}
                      </option>
                    ))
                  ) : (
                    <option value="">Loading stations...</option>
                  )}
                </select>








                </div>
                <div className="form-group">
                <label htmlFor="latitude">Latitude</label>
                <input
                  id="latitude"
                  type="text"
                  name="latitude"
                  placeholder="Latitude"
                  value={formData.latitude}
                  onChange={handleInputChange}
                />
                </div>
                <div className="form-group">
                <label htmlFor="longitude">Longitude</label>
                <input
                  id="longitude"
                  type="text"
                  name="longitude"
                  placeholder="Longitude"
                  value={formData.longitude}
                  onChange={handleInputChange}
                />
                </div>
                <div className="form-group">
                <label htmlFor="longitude">Get Current Location</label>
                <button
                  type="button"
                  onClick={handleFlyToCurrentLocation}
                  className="lat-long-btn"
                >
                  <img src={LatLongIcon} alt="Lat Long Icon" />
                </button>
                </div>
              </div>
              <div className="form-group">
              <label htmlFor="locationDescription">Location Description</label>
              <textarea
                id="locationDescription"
                name="locationDescription"
                placeholder="Location Description"
                value={formData.locationDescription}
                onChange={handleInputChange}
              />
              </div>
            </div>

            {/* Additional Details */}
            <div className="additional-details">
            
            <div className="field-group">
              <label htmlFor="girth">Add Girth</label>
              <div className="input-box">
                <input
                  id="girth"
                  type="text"
                  name="girth"
                  placeholder="Enter Girth"
                  value={formData.girth}
                  onChange={handleInputChange}
                />
                <select
                  name="girthUnit"
                  value={formData.girthUnit}
                  onChange={handleInputChange}
                >
                  <option value="cm">CM</option>
                  <option value="m">M</option>
                </select>
              </div>
            </div>

            {/* Height Input */}
            <div className="field-group">
              <label htmlFor="height">Add Height</label>
              <div className="input-box">
                <input
                  id="height"
                  type="text"
                  name="height"
                  placeholder="Enter Height"
                  value={formData.height}
                  onChange={handleInputChange}
                />
                <select
                  name="heightUnit"
                  value={formData.heightUnit}
                  onChange={handleInputChange}
                >
                  <option value="cm">CM</option>
                  <option value="m">M</option>
                </select>
              </div>
            </div>

             <div className="field-group">
                  <label htmlFor="package">Package</label>
                  <div className="input-box">
                  <input
                    id="package"
                    type="text"
                    name="package"
                    placeholder="Add Package"
                    value={formData.package}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
          
            </div>

            <div className="form-group">
              <label htmlFor="remark">Remarks</label>
              <textarea
                id="remark"
                name="remark"
                placeholder="Enter Remarks Here..."
                value={formData.remark}
                onChange={handleInputChange}
              />
              </div>
                <button type="submit" className="submit-button">
                  SUBMIT
                </button>
            </div>
        </div>
      </div>
    </form>
  );
};

export default TreeGeotaggingForm;





































